Application.Postcard.Message = {
    ui: {
        container: '.js-postcard-message',
        textarea: '.js-postcard-message__textarea'
    },
    postcard: null,
    ready: function (postcard) {

        if (!$(this.ui.container).length){
            return;
        }

        // assign
        this.postcard = postcard;

        // bind handlers
        this.bind();

        // update on load
        this.update();

    },
    bind: function(){

        var self = this;

        // update postcard on textarea change
        $(document).on('keyup change', this.ui.textarea, this.update.bind(this));

    },
    update: function(){

        var text = $(this.ui.textarea).val();
        this.postcard.setMessage(text);

    }
};